import { useEffect, useState } from 'react'
import { toast } from '@sales-center/components'

import { getLeadDetail } from '../api'
import { clearLeadDetail } from '../slice'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useNavigate } from 'react-router-dom'

export const useGetLeadDetailOnMount = (leadId?: number) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    if (!leadId) {
      dispatch(clearLeadDetail)
      setStatus('success')

      return () => {
        mounted = false
      }
    }

    // WWM-18150 - reset to 'pending' on every leadId change, not just the first mount. See the
    // matching comment in useGetOpportunityDetailOnMount for why this is required.
    setStatus('pending')

    const execute = async () => {
      try {
        const result = await dispatch(getLeadDetail(leadId))

        if (mounted) {
          if (getLeadDetail.fulfilled.match(result)) {
            setStatus('success')
          } else {
            if (result.payload?.Message === 'Permission denied') {
              navigate('/access-denied')
            } else {
              setStatus('fail')
              toast.error(
                result.payload?.Message || 'Error loading lead details.',
              )
            }
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, leadId, navigate])

  return status
}
